import { createContext } from "react"
import type { ToastType } from "~/ur-react-components"

export interface ToastInfo {
  id: string
  type: ToastType
  message: string
  options?: ToastOptions
}

export interface ToastOptions {
  life?: number
}

export type AddToastFn = (
  type: ToastType,
  message: string,
  options?: ToastOptions,
) => void

export const ToastContext = createContext<AddToastFn>(() => {})
